import { render, staticRenderFns } from "./couponBuyRecord.vue?vue&type=template&id=62e51582&scoped=true"
import script from "./couponBuyRecord.vue?vue&type=script&lang=js"
export * from "./couponBuyRecord.vue?vue&type=script&lang=js"
import style0 from "./couponBuyRecord.vue?vue&type=style&index=0&id=62e51582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e51582",
  null
  
)

export default component.exports